import { ACTIVE_SERVER_ID } from 'mk/settings';
import { getWikiArticleUrl } from 'mk2/apps/wiki/urls';

export const aboutUrl = '/about/';
export const aboutPrivacyAndCookiePolicyUrl = '/about/privacy-and-cookie-policy/';

const ABOUT_PAGES: { [pageSlug: string]: string } = {
    'rules-common': {
        201: 'vseobecne-podmienky-pouzivania',
        202: 'vseobecne-podminky-pouzivani',
        207: 'rules-common',
    }[ACTIVE_SERVER_ID],
    'rules-codex': {
        201: 'kodex-spravania-na-stranke',
        202: 'kodex-chovani-na-strance',
        207: 'rules-codex',
    }[ACTIVE_SERVER_ID],
    'rules-market': {
        201: 'pravidla-bazara',
        202: 'pravidla-bazaru',
        207: 'rules-market',
    }[ACTIVE_SERVER_ID],
    'contact': {
        201: 'kontakt-a-fakturacne-udaje',
        202: 'kontakt-a-fakturacni-udaje',
        207: 'contact',
    }[ACTIVE_SERVER_ID],
    'data-processor': {
        201: 'podmienky-spracuvania-osobnych-udajov-pre-predajcov',
        202: 'podminky-zpracovani-osobnich-udaju-pro-prodejce',
        207: 'data-processor',
    }[ACTIVE_SERVER_ID],
    'privacy-policy': {
        201: 'zasady-ochrany-osobnych-udajov',
        202: 'zasady-ochrany-osobnich-udaju',
        207: 'privacy-policy',
    }[ACTIVE_SERVER_ID],
    'cookie-policy': {
        201: 'cookie-pravidla',
        202: 'cookie-pravidla',
        207: 'cookie-policy',
    }[ACTIVE_SERVER_ID],
    'google-partners-list': {
        201: 'partneri-reklamnej-siete-google',
        202: 'partneri-reklamni-site-google',
        207: 'partners-of-google-ads-network',
    }[ACTIVE_SERVER_ID],
};

const ABOUT_PAGES_CATEGORY = {
    201: 'ine',
    202: 'jine',
    207: 'other',
}[ACTIVE_SERVER_ID];

export const aboutRulesCommonUrl = getWikiArticleUrl(ABOUT_PAGES_CATEGORY, ABOUT_PAGES['rules-common']);
export const aboutRulesCodexUrl = getWikiArticleUrl(ABOUT_PAGES_CATEGORY, ABOUT_PAGES['rules-codex']);
export const aboutRulesMarketUrl = getWikiArticleUrl(ABOUT_PAGES_CATEGORY, ABOUT_PAGES['rules-market']);
export const aboutCookiePolicyUrl = getWikiArticleUrl(ABOUT_PAGES_CATEGORY, ABOUT_PAGES['cookie-policy']);
export const aboutContactUrl = getWikiArticleUrl(ABOUT_PAGES_CATEGORY, ABOUT_PAGES.contact);
export const aboutPrivacyPolicyUrl = getWikiArticleUrl(ABOUT_PAGES_CATEGORY, ABOUT_PAGES['privacy-policy']);
export const aboutDataProcessorUrl = getWikiArticleUrl(ABOUT_PAGES_CATEGORY, ABOUT_PAGES['data-processor']);
export const aboutGooglePartnersListUrl = getWikiArticleUrl(ABOUT_PAGES_CATEGORY, ABOUT_PAGES['google-partners-list']);
